import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AnimatedLink } from '../../components/animated-link/AnimatedLink';

import './testimonials.scss';
import '../quote_block.scss';

const HomeIframe: React.FC<React.DetailedHTMLProps<
  React.IframeHTMLAttributes<HTMLIFrameElement>,
  HTMLIFrameElement
>> = props => {
  return (
    <iframe
      {...props}
      title={props.title}
      height="169"
      width="300"
      frameBorder="0"
      allowFullScreen
    />
  );
};

export const Testimonials: React.FC = () => {
  return (
    <div className="banner-customers--grey">
      <div className="banner-customers__block">
        <div className="banner-customers__interview__header">
          <h2 className="banner-customers__title">
            <FormattedMessage id="presentation/testimonials/Testimonials.tsx/1" />
          </h2>
        </div>

        <div className="testimonials__grid">
          <div className="testimonials__unit">
            <HomeIframe
              title="diane-visinet-video"
              src="https://www.youtube.com/embed/NStZt159oM4"
            />
            <div className="testimonials__description">
              <div className="testimonials__name">
                <FormattedMessage id="presentation/testimonials/Testimonials.tsx/2" />
              </div>
              <div className="testimonials__job">
                <FormattedMessage id="presentation/testimonials/Testimonials.tsx/3" />
              </div>
            </div>
          </div>
          <div className="testimonials__unit">
            <HomeIframe
              title="benjamin-moutte-caruel-video"
              src="https://www.youtube.com/embed/w0SzjlQtkDM"
            />
            <div className="testimonials__description">
              <div className="testimonials__name">
                <FormattedMessage id="presentation/testimonials/Testimonials.tsx/4" />
              </div>
              <div className="testimonials__job">
                <FormattedMessage id="presentation/testimonials/Testimonials.tsx/5" />
              </div>
            </div>
          </div>
          <div className="testimonials__unit">
            <HomeIframe
              title="francois-mazon-video"
              src="https://www.youtube.com/embed/11V5bBUkB-4"
            />
            <div className="testimonials__description">
              <div className="testimonials__name">
                <FormattedMessage id="presentation/testimonials/Testimonials.tsx/6" />
              </div>
              <div className="testimonials__job">
                <FormattedMessage id="presentation/testimonials/Testimonials.tsx/7" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="testimonials__link-container">
        <div className="vertical-align-elements">
          <AnimatedLink href="/avis" source="testimonials_banner">
            <span>
              <FormattedMessage id="presentation/testimonials/Testimonials.tsx/8" />
            </span>
          </AnimatedLink>
        </div>
      </div>
    </div>
  );
};
